// 项目名字
export const websitname = "kissmevv";
// 页面默认title
export const defaultTitle = "kissmevv";
// 网站地址
// export const websiteurl = "https://www.kissmevv.com";
export const websiteurl = "https://www.kissmevv.com";
// Email
export const email = "kissmevv@outlook.com";
// 账户名称
export const account = "kissmevv";
// 图片域名
export const imgurl =
  process.env.NODE_ENV == "development" ? "http://localhost:6677" : "https://www.kissmevv.com";

// websocket
export const webSocketUrl =   process.env.NODE_ENV == "development" ? "ws://127.0.0.1:6679" : "wss://www.kissmevv.com/wss/";
//  export const webSocketUrl = "ws://192.168.8.24:6679";
// export const webSocketUrl = "ws://localhost:2345/";


